<template>
  <Modal :show="true" centered size="xxl" title="Liquidación de Orden de Servicio" @hide="$emit('hide')" bodyClass="p-0">
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <div class="card-body">
        <div class="row align-items-center mb-3">
          <div class="col-12 col-lg mb-3 mb-sm-0">
            <ul class="list-inline mb-0">
              <li class="list-inline-item"><strong>Servicio:</strong> {{ modalItem.servicio }}</li>
              <li class="list-inline-item"><strong>Fecha:</strong> {{ modalItem.fecha | date }}</li>
              <li class="list-inline-item"><strong>Código:</strong> {{ modalItem.codigo }}</li>
              <li class="list-inline-item"><strong>Idioma:</strong> {{ modalItem.idioma }}</li>
              <template v-if="estaLiquidado">
                <li class="list-inline-item"><strong>Fecha Liquidación:</strong> {{ liquidado.fechaLiquidacion | date }}</li>
              </template>
            </ul>
          </div>
          <div class="col-12 col-lg-3">
            <div class="text-sm-right">
              <button v-if="!estaLiquidado" @click="onLiquidar" class="btn btn-sm btn-primary mr-2" :disabled="loading.save || estaLiquidado">
                Liquidar
              </button>
              <router-link v-else :to="{ name: 'liquidaciones', query: { codRegistro: modalItem.codigo } }" class="btn btn-sm btn-outline-success mr-2">
                Ver liquidación
              </router-link>
              <button @click="onPrint" class="btn btn-sm btn-outline-secondary">
                Imprimir
              </button>
            </div>
          </div>
        </div>
      </div>
      <ValidationObserver ref="formTable">
        <OrdenDeServicioLiquidarTable></OrdenDeServicioLiquidarTable>
      </ValidationObserver>
    </template>
  </Modal>
</template>

<script>
import OrdenDeServicioLiquidarTable from "./OrdenDeServicioLiquidarTable.vue";
import Spinner from "../../shared/components/Spinner.vue";
import Modal from "../../shared/components/Modal.vue";
import { mapGetters, mapState } from "vuex";
import pdfOrdenLiquidacion from "@/pdfs/pdfOrdenLiquidacion";

export default {
  components: { Modal, Spinner, OrdenDeServicioLiquidarTable },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    modalItem: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        view: true,
        save: false,
      },
    };
  },
  async created() {
    let vm = this;
    let response;

    try {
      response = await vm.axios.get(`/ordenes/${vm.modalItem.idOrden}/liquidacion`);
    } catch (error) {
      return;
    }

    const listArr = response.data.content.registros.map((item, index) => ({
      ...item,
      id: index + 1,
      tarifa: Number(item.tarifa),
      observaciones: response.data.content.liquidado ? item.observaciones : "",
      isNew: false,
      tempMoneda: item.moneda || "USD",
    }));

    vm.$store.commit("ordenDeServicio.liquidar/load", {
      list: listArr,
      liquidado: response.data.content.liquidado,
      monedas: response.data.content.monedas,
    });

    vm.loading.view = false;
  },
  computed: {
    ...mapGetters("ordenDeServicio.liquidar", ["total", "estaLiquidado", "monedas"]),
    ...mapState("ordenDeServicio.liquidar", {
      list: "list",
      liquidado: "liquidado",
    }),
  },
  methods: {
    async onLiquidar() {
      const vm = this;

      const success = await vm.$refs.formTable.validate();
      if (!success) {
        vm.$toast.fire("", "Completa los campos requeridos", "warning");
        return;
      }

      const id_por_moneda = vm.monedas.reduce((obj, item) => {
        obj[item.sigla] = item.idMoneda;
        return obj;
      }, {});

      const list = [...vm.list].map((item) => {
        return {
          ...item,
          idMoneda: id_por_moneda[item.tempMoneda],
        };
      });

      vm.loading.save = true;

      vm.axios
        .post(`/ordenes/${vm.modalItem.idOrden}/liquidacion`, {
          items: list,
          // total: vm.total,
        })
        .then((response) => {
          vm.$store.dispatch("ordenDeServicio.liquidar/save", response.data.content);

          vm.$toast.fire(response.data.message, "", "success");
        })
        .finally(() => {
          vm.loading.save = false;
        });
    },
    onPrint() {
      const vm = this;

      const items = vm.list.map((item) => ({
        agencia: item.agencia,
        file: item.file,
        nombre: item.nombre,
        nroAdultos: item.nroAdultos,
        nroNinos: item.nroNinos,
        hotel: item.hotel || item.otroHotel || "",
        servicioTipo: item.servicioTipo || item.otroServicioTipo || "",
        moneda: vm.estaLiquidado ? item.moneda : item.tempMoneda,
        tarifa: {
          alignment: "center",
          text: item.tarifa ? vm.$options.filters.number(item.tarifa, 2) : "0.00",
        },
        observaciones: item.observaciones || "",
      }));

      Object.keys(vm.total).forEach((moneda) => {
        items.push({
          agencia: {
            colSpan: 8,
            alignment: "right",
            text: `TOTAL ${moneda}`,
          },
          tarifa: {
            alignment: "center",
            text: vm.$options.filters.number(vm.total[moneda], 2),
          },
          observaciones: "",
        });
      });

      pdfOrdenLiquidacion({
        items,
        header: {
          servicio: vm.modalItem.servicio,
          fecha: vm.$options.filters.date(vm.modalItem.fecha),
          codigo: vm.modalItem.codigo,
          idioma: vm.modalItem.idioma,
          fechaLiquidacion: vm.estaLiquidado ? vm.$options.filters.date(vm.liquidado.fechaLiquidacion) : "",
        },
        preview: !vm.estaLiquidado,
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format("DD-MM-YY HH:mm"),
      });
    },
  },
};
</script>
